__turbopack_context__.v({
  "close": "GallerySliderModalMobile-module-scss-module__CnA1cW__close",
  "content": "GallerySliderModalMobile-module-scss-module__CnA1cW__content",
  "contentHidden": "GallerySliderModalMobile-module-scss-module__CnA1cW__contentHidden",
  "cursorImg": "GallerySliderModalMobile-module-scss-module__CnA1cW__cursorImg",
  "imgNoCursor": "GallerySliderModalMobile-module-scss-module__CnA1cW__imgNoCursor",
  "imgWrapper": "GallerySliderModalMobile-module-scss-module__CnA1cW__imgWrapper",
  "nav": "GallerySliderModalMobile-module-scss-module__CnA1cW__nav",
  "nav__counter": "GallerySliderModalMobile-module-scss-module__CnA1cW__nav__counter",
  "selector": "GallerySliderModalMobile-module-scss-module__CnA1cW__selector",
  "selector__active": "GallerySliderModalMobile-module-scss-module__CnA1cW__selector__active",
  "selector__arrow": "GallerySliderModalMobile-module-scss-module__CnA1cW__selector__arrow",
  "selector__arrow_down": "GallerySliderModalMobile-module-scss-module__CnA1cW__selector__arrow_down",
  "selector__list": "GallerySliderModalMobile-module-scss-module__CnA1cW__selector__list",
  "selector__switch": "GallerySliderModalMobile-module-scss-module__CnA1cW__selector__switch",
  "swiper": "GallerySliderModalMobile-module-scss-module__CnA1cW__swiper",
  "swiperAnimated": "GallerySliderModalMobile-module-scss-module__CnA1cW__swiperAnimated",
});
